module.exports = __webpack_public_path__ + "static/media/22ESCWA6.250a5e20.jpg";